/* Release alerts sign-up (sections/holo-alerts.liquid).
 *
 * Progressive enhancement over Shopify's native customer form: on submit it
 * joins the ticked game chips into the single hidden contact[tags] field.
 * It must NOT preventDefault and must NOT post via fetch — only a native
 * submit gets the spam-protection token (see assets/holo-op.js). The rebuild
 * always starts from 'release-alerts', so a captcha resubmit is idempotent.
 *
 * Without this script the hidden field still posts `release-alerts`.
 */
(function () {
  'use strict';

  function setup(root) {
    var form = root.querySelector('form');
    var tagsEl = root.querySelector('[data-alerts-tags]');
    if (!form || !tagsEl) return;

    form.addEventListener('submit', function () {
      var tags = ['release-alerts'];
      Array.prototype.forEach.call(
        form.querySelectorAll('input[type="checkbox"][data-tag]:checked'),
        function (box) { tags.push(box.getAttribute('data-tag')); }
      );
      tagsEl.value = tags.join(',');
    });
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-alerts]'), setup);
})();
